import { render, staticRenderFns } from "./sky-mainInput.vue?vue&type=template&id=230bc292&scoped=true"
import script from "./sky-mainInput.vue?vue&type=script&lang=js"
export * from "./sky-mainInput.vue?vue&type=script&lang=js"
import style0 from "./sky-mainInput.vue?vue&type=style&index=0&id=230bc292&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "230bc292",
  null
  
)

export default component.exports